"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = exports.ImageWrapper = exports.ContentWrapper = exports.CompareWrapper = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
  flex-direction: column;
`;
exports.Container = Container;
const ContentWrapper = styled_components_1.default.div `
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: auto;
  width: 100%;
`;
exports.ContentWrapper = ContentWrapper;
const ImageWrapper = styled_components_1.default.div `
  width: 302px;
  & > div:first-of-type {
    margin: ${({ theme }) => `${theme.spacings.xl} 0 ${theme.spacings.m}`};
  }
`;
exports.ImageWrapper = ImageWrapper;
const CompareWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin: 5.5rem 0.5rem 0;
`;
exports.CompareWrapper = CompareWrapper;
const TopBar = styled_components_1.default.div `
  display: flex;
`;
exports.TopBar = TopBar;
//# sourceMappingURL=Layout.js.map